import React from 'react'

function BenefitsPage() {
  return (
    <div>BenefitsPage</div>
  )
}

export default BenefitsPage